import React from "react";
import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import EmailSignatureIndex from "../../../components/SidetabPages/EmailSignature/EmailSignatureIndex";

const EmailSignature = () => {
  return (
    <>
      <AnnouncementBar />
      <EmailSignatureIndex />
    </>
  );
};
export default EmailSignature;
